import React from "react";
import Chip from '@material-ui/core/Chip';
import Tooltip from "@material-ui/core/Tooltip";

const SecurityCell = (rowData) => {
  let details = (rowData.context || {}).ip_details || {};
  if (!rowData.context) return null;

  return (
    <React.Fragment>
      <Tooltip title={(details||{}).provider}>
        <span>{rowData.context.ip}</span>
      </Tooltip>
      <br/>

      {details.proxy==="yes" && (
        <Chip label={`${details.type}: ${details.risk}`} size="small" color="secondary"/>

      )}
      {details.proxy==="no" && (
        <Chip label={`${details.type}${details.risk>0?": "+details.risk:""}`} size="small" color="primary" variant="outlined"/>
      )}      
    </React.Fragment>
  );
};

export default SecurityCell;
